import { Bills } from "@hagerty/self-service-components/payments";
import { useBillingPayment } from "./useBillingPayment";
import styles from "./BillingPayment.module.scss";

export const heading = "Upcoming Bills";

export const BillingPayment = () => {
  const { bills } = useBillingPayment();

  return (
    <div className={styles.container}>
      <Bills
        isLoading={false}
        bills={bills}
        returnButtonLabel="Return to Account Dashboard"
        returnUrl={window.location.href}
        // TODO: add tealium tracking here
        // onBillAction={(actionType, bill) => {
        //   console.log(actionType, bill);
        // }}
      />
    </div>
  );
};
